
<div id="permanent_planning_questionnaire">
    <div class="title_card">
        {{'ACTIONS' | translate}}
        @if(this.currentObjId && this.displayAll){
            <div>{{this.getObjectivesStatusIndex()}} / {{this.objectivesStatus.size}}</div>
        }
    </div>   

    @if(this.isFetching){
        <div class="bloc_loading">
            <ion-spinner></ion-spinner>
        </div>  
    }
    @else{
        @if(this.objectivesStatus.size > 0){
            @if(this.model){
                <app-questionnaire 
                    [model]="this.model"
                    [values]="this.inputsFieldsValues"
                    [title]="this.model.name"
                    [disabled]="this.disabledQuestionnaire"
                    (onValidateQuestionnaire)="this.onValidateQuestionnaire($event)"
                    />
            }
        }
        @else{
            <marv-message type="info">{{'MSG_NO_PLANNING_OBJECTIVES_REPORTS' | translate}}</marv-message>
        }
    }
</div>